import React, { useEffect, useState, useCallback } from "react";
import BalanceUI from "../components/BalanceUI";
import { getUser } from "../../auth";
import socket from "../../socket";

const URL = process.env.REACT_APP_API_URL;

export default function Balance() {
  const [monthlyBalance, setMonthlyBalance] = useState(0);

  const fetchBalance = useCallback(async () => {
    const user = getUser();
      try {
        const response = await fetch(`${URL}/api/activity/balance/mensual`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "X-Empresa-Id": user?.empresa_id,
          },
        });

        if (!response.ok) throw new Error("Fallo la solicitud");

        const data = await response.json();
        setMonthlyBalance(data.balance);
      } catch (error) {
        console.error("Error al obtener el balance mensual:", error);
      }
  }, []);

  useEffect(() => {
    fetchBalance();
  
    socket.on("actividad_creada", fetchBalance);
    socket.on("actividad_borrada", fetchBalance);
    socket.on("actividad_editada", fetchBalance);
  
    return () => {
      socket.off("actividad_creada", fetchBalance);
      socket.off("actividad_borrada", fetchBalance);
      socket.off("actividad_editada", fetchBalance);
    };
  }, [fetchBalance, monthlyBalance]);


  return (
    <BalanceUI
      balance={monthlyBalance}
    />
  )
}
